import { AsyncPipe, NgForOf, NgIf } from '@angular/common';
import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { ETimeFormat, injectEnvironment } from '@cf/core';
import { TranslateCutPipe } from '@cf/features/i18n';
import { ButtonDirective, LinkComponent } from '@cf/shared/ui/button';
import { CfIconDirective } from '@cf/shared/ui/icons';
import { DateFormatPipe, TextComponent } from '@cf/shared/ui/typography';
import { AccountService, AuthService, IEventContainer, TimeFormatEnum } from '@cf/temp/services';
import { NgxTolgeeModule } from '@tolgee/ngx';
import { BookingLoginComponent } from '../booking-login/booking-login.component';

@Component({
  selector: 'cf-booking-availability',
  templateUrl: './booking-availability.component.html',
  styleUrls: ['./booking-availability.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [
    NgxTolgeeModule,
    TextComponent,
    DateFormatPipe,
    NgIf,
    NgForOf,
    LinkComponent,
    BookingLoginComponent,
    AsyncPipe,
    CfIconDirective,
    ButtonDirective,
    TranslateCutPipe,
  ],
})
export class BookingAvailabilityComponent {
  @Input({ required: true }) date!: string;
  @Input({ required: true }) events!: IEventContainer[];
  @Input({ required: true }) isAuthorized!: boolean | null;
  @Input() isPreview!: boolean;
  showLoginForm = false;
  private environment = injectEnvironment();

  @Input() set timeFormat(value: string) {
    if (value) {
      this._timeFormat = value === TimeFormatEnum['24h'] ? 24 : 12;
    }
  }

  get timeFormat() {
    return this._timeFormat === 12 ? ETimeFormat.TIME_12 : ETimeFormat.TIME_24;
  }

  _timeFormat = 24;

  constructor(
    private readonly authService: AuthService,
    public accountService: AccountService,
  ) {}

  signUpRedirect(): void {
    window.open(`${this.environment.appUrl}/auth/sign-up`, '_blank');
  }

  logout(): void {
    this.authService.logout(true);
  }
}
